import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { legalValue, useLegalIdentity } from '../../lib/legalIdentity';

/** sessionStorage: «Aviso de demo cerrado» (doc. 04, tabla de tecnologías). */
export const DEMO_BANNER_STORAGE_KEY = 'pizas_demo_banner_dismissed';

function bannerEnabled() {
  const v = (process.env.REACT_APP_DEMO_SITE_BANNER || '').trim().toLowerCase();
  return !(v === '0' || v === 'false' || v === 'off' || v === 'no');
}

/**
 * Banner superior «Sitio de demostración» (doc. 05 §2). Páginas públicas; se puede cerrar por sesión.
 * Se oculta también si en «Identidad y contacto» se desmarca «Sitio de demostración».
 */
export default function DemoSiteBanner() {
  const location = useLocation();
  const { identity, loading } = useLegalIdentity();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DEMO_BANNER_STORAGE_KEY) === '1';
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    if (/^\/(admin|super)(\/|$)/i.test(location.pathname)) setDismissed(true);
  }, [location.pathname]);

  if (!bannerEnabled() || dismissed) return null;
  if (!loading && identity && identity.demo_site === false) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(DEMO_BANNER_STORAGE_KEY, '1');
    } catch (_) {
      /* sessionStorage bloqueado */
    }
    setDismissed(true);
  };
  const trade = legalValue(identity, 'trade_name') || 'DanySolutions';
  const brand = legalValue(identity, 'store_brand') || 'Pizzas';

  return (
    <div className="bg-[#F2B33D] text-[#2B1A12]" role="region" aria-label="Aviso de sitio de demostración" data-testid="demo-site-banner">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-start sm:items-center gap-3 text-sm leading-snug">
        <p className="flex-1">
          <strong>Sitio de demostración</strong> de {trade}. «{brand}» es una pizzería de ejemplo: puede usar datos de
          prueba. No se realizan cargos reales.{' '}
          <Link to="/terminos#demo" className="font-semibold underline underline-offset-2 hover:no-underline">
            Más información
          </Link>
        </p>
        <button
          type="button"
          onClick={dismiss}
          className="shrink-0 rounded-full border border-[#2B1A12]/40 px-3 py-1 text-xs font-bold hover:bg-[#2B1A12] hover:text-[#FFF6EA] min-h-[32px]"
          data-testid="demo-site-banner-dismiss"
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
